import { getCookie } from 'cookies-next';
import { OptionsType } from 'cookies-next/lib/common/types';

// pass {req,res} as context when using server-side
export const getUserId = (context?: OptionsType) =>
  getCookie('user_id', context);

export const isLoggedIn = (context?: OptionsType) =>
  getUserId(context) !== undefined;
